<template>
  <div class="RegisterDialog">
    <el-dialog
      :visible.sync="dialogVisible"
      width="400px"
      custom-class="register_dialog"
      :before-close="handleClose"
    >
      <div class="register_title">注册青叶账号</div>
      <el-form :model="form" :rules="rules" ref="registerForm" label-position="top">
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="form.phone"
            placeholder="请输入手机号"
            maxlength="11"
            @keyup.enter.native="handleRegister"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <div class="code_row">
            <el-input
              v-model="form.code"
              placeholder="请输入验证码"
              maxlength="6"
              @keyup.enter.native="handleRegister"
            ></el-input>
            <el-button
              class="code_btn"
              :disabled="countdown > 0"
              @click="sendCode"
            >{{ countdown > 0 ? countdown + "s后重发" : "获取验证码" }}</el-button>
          </div>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入密码（至少6位）"
            @keyup.enter.native="handleRegister"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="form.confirmPassword"
            type="password"
            placeholder="请再次输入密码"
            @keyup.enter.native="handleRegister"
          ></el-input>
        </el-form-item>
        <el-button class="register_btn" :loading="loading" @click="handleRegister">注 册</el-button>
      </el-form>
      <div class="register_login">
        已有账号？
        <span class="register_login_link" @click="handleToLogin">立即登录</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "RegisterDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (/^1[3-9]\d{9}$/.test(value)) {
        return callback();
      }
      callback("请输入正确的手机号");
    };
    var checkConfirm = (rule, value, callback) => {
      if (value !== this.form.password) {
        return callback("两次输入的密码不一致");
      }
      callback();
    };
    return {
      loading: false,
      countdown: 0,
      timer: null,
      sentCode: "",
      form: {
        phone: "",
        code: "",
        password: "",
        confirmPassword: "",
      },
      rules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 6, max: 6, message: "验证码为6位数字", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "密码至少6位", trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: checkConfirm, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    //注册成功后清空表单和校验状态
    resetForm() {
      this.form.phone = "";
      this.form.code = "";
      this.form.password = "";
      this.form.confirmPassword = "";
      this.sentCode = "";
      this.$nextTick(() => {
        this.$refs.registerForm.clearValidate();
      });
    },
    sendCode() {
      this.$refs.registerForm.validateField("phone", (errMsg) => {
        if (errMsg) return;
        this.$store.dispatch("auth/sendCode", { phone: this.form.phone, scene: "register" }).then((data) => {
          this.$message.success(data && data.smsCode ? "验证码已发送：" + data.smsCode : "验证码已发送");
          this.countdown = 60;
          this.timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) clearInterval(this.timer);
          }, 1000);
        }).catch((err) => {
          this.$message.error((err && err.msg) || "验证码发送失败");
        });
      });
    },
    handleRegister() {
      this.$refs.registerForm.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        this.$store.dispatch("auth/register", {
          phone: this.form.phone,
          code: this.form.code,
          password: this.form.password,
        }).then(() => {
          this.loading = false;
          this.$message.success("注册成功，请登录");
          this.$emit("success");
          this.handleClose();
          this.resetForm();
        }).catch((err) => {
          this.loading = false;
          this.$message.error((err && err.msg) || "注册失败");
        });
      });
    },
    handleToLogin() {
      this.$emit("login");
      this.handleClose();
    },
  },
};
</script>

<style scoped>
.RegisterDialog >>> .register_dialog {
  border-radius: 8px;
}

.RegisterDialog >>> .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.RegisterDialog >>> .register_dialog {
  margin: 0 !important;
}

.RegisterDialog >>> .register_dialog .el-dialog__header {
  padding: 0;
}

.RegisterDialog >>> .register_dialog .el-dialog__body {
  padding: 28px 32px 20px;
}

.register_title {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  padding-bottom: 16px;
}

.RegisterDialog >>> .el-form-item {
  margin-bottom: 16px;
}

.RegisterDialog >>> .el-form--label-top .el-form-item__label {
  padding-bottom: 4px;
  line-height: 20px;
}

.code_row {
  display: flex;
  gap: 10px;
}

.code_row .el-input {
  flex: 1;
}

.code_btn {
  flex-shrink: 0;
  height: 40px;
  background: #1b63a7;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 0 14px;
  font-size: 13px;
}

.code_btn:hover {
  background: #2968bd;
  border-color: #2968bd;
}

.code_btn.is-disabled {
  background: #a0cfff;
  border-color: #a0cfff;
  color: #fff;
}

.register_btn {
  width: 100%;
  height: 44px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #2968bd, #1b63a7);
  border: none;
  border-radius: 8px;
  margin-top: 4px;
}

.register_btn:hover {
  box-shadow: 0 2px 8px rgba(27, 99, 167, .35);
}

.register_login {
  text-align: center;
  font-size: 13px;
  color: #999999;
  padding-top: 14px;
}

.register_login_link {
  color: #2968bd;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/components/RegisterDialog.vue